import { useMemo } from "react";
import { useAuthContext } from "@/auth/AuthProvider";
import type { ProfileMenuItem } from "../Header.types";

export function useProfileMenuItems(
  onChangeGroup: () => void,
): ProfileMenuItem[] {
  const { logout } = useAuthContext();

  return useMemo(
    () => [
      {
        icon: (
          <span className="material-symbols-outlined text-xl leading-none text-black">
            tune
          </span>
        ),
        title: "Change Group",
        description: "Change your active group",
        action: onChangeGroup,
      },
      {
        icon: (
          <span className="material-symbols-outlined text-xl leading-none text-black">
            logout
          </span>
        ),
        title: "Log out",
        description: "Log out of Salerio",
        action: logout,
      },
    ],
    [logout, onChangeGroup],
  );
}
